import React from 'react';
import CompanyItem from "./CompanyItem";
import SectionsItem from "./SectionsItem";
import BranchesItem from "./BranchesItem";

const SelectBranch = () => {
    return (
        <>
            <CompanyItem />
            <SectionsItem />
            <BranchesItem />
        </>
    );
};

export default SelectBranch;